var map = {
	"./0001.png": "e22f",
	"./0002.png": "952f",
	"./0003.png": "bdd6",
	"./0004.png": "e259",
	"./0005.png": "9c8a",
	"./0006.png": "8970",
	"./0007.png": "a446",
	"./0008.png": "2f94",
	"./0009.png": "4684"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "86c0";